<template>
  <div>
    <div v-show="error !== ''">
      <v-alert
        :value="true"
        type="error">
        {{ error }}
      </v-alert>
    </div>

    <v-flex xs12>
      <div v-show="loading" class="text-xs-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        v-show="!loading"
      >
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="begin"
          lazy
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-text-field
            v-model="begin"
            label="開始日"
            prepend-icon="event"
            readonly
            v-on="on"
            ></v-text-field>
          </template>


          <v-date-picker v-model="begin" no-title scrollable locale="ja-jp">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.menu1.save(begin)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="end"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            v-model="end"
            label="終了日"
            prepend-icon="event"
            readonly
            v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="end" no-title scrollable locale="ja-jp">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.menu2.save(end)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-data-table
          :headers='headers'
          :items='days'
          class="elevation-1"
          dark
          hide-actions
        >
          <template v-slot:items="props" >
            <td>{{ props.item.name }}</td>
            <td>
              <v-btn flat icon @click='props.item.data = !props.item.data'>
                <v-icon>{{ ox(props.item.data) }}</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>

        <v-layout align-center justify-end row fill-height>
          <v-btn @click="submit" color="error">実行</v-btn>
        </v-layout>
      </v-form>
    </v-flex>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialog"
          max-width="290"
        >
          <v-card>
            <v-card-title class="headline">{{dialog_title}}</v-card-title>

            <v-card-text style="white-space: pre-line">
              {{dialog_content}}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color='info'
                @click="dialog = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    ox: (yn) => {
      return yn ? "radio_button_unchecked" : "clear"
    },
    async submit() {
      this.loading = true
      this.error = ""

      let skips = []
      let eatDays = [true].concat(this.days.map((x) => x.data))
      const begin = this.$moment(this.begin)
      const end = this.$moment(this.end)

      if(end.isBefore(begin)){
        this.loading = false
        this.error = "開始日と終了日が逆転しています"
        return false
      }

      for(let date = begin; date <= end; date.add(1, 'day')){
        if(!eatDays[date.day()]){
          skips.push({type:'add', skipping: {date: this.date2num(date), is_breakfast: 0}})
        }else{
          skips.push({type:'remove', skipping: {date: this.date2num(date), is_breakfast: 0}})
        }
      }

      try{
        let result = await this.api('skipping_update', {requests: skips})
        let result_str = result.payload.results.map((x) => `${x.request.skipping.date}:${x.result} ` + (x.reason || ''))
        this.dialog_title = '成功'
        this.dialog_content = '以下のように変更しました\n' + result_str.join('\n')
        this.dialog = true
      }
      catch (e) {
        this.dialog_title = 'エラー'
        this.dialog_content = e.message
        this.dialog = true
      }
      finally {
        this.loading = false
      }

    }
  },
  data () {
    return {
      begin: this.$moment().add(2, "week").startOf('isoweek').add(1, "day").format("YYYY-MM-DD"),
      end: this.$moment().add(2, "week").startOf('isoweek').add(6, "day").format("YYYY-MM-DD"),
      days: [{name:"月", data:true},{name:"火", data:true},{name:"水", data:true},{name:"木", data:true},{name:"金", data:true},{name:"土", data:true}],
      headers: [{ text: '曜日', value: 'namem', sortable:false}, { text: '欠食', value: 'data', sortable:false}],
      valid: true,
      menu1: false,
      menu2: false,
      loading: false,
      user: localStorage.user || "",
      dialog: false,
      dialog_content: '',
      dialog_title: '',
      error: ''
    }
  }
}
</script>

<style>

</style>


